<template>
    <div class="d-flex align-center text-body-2">
        <span class="caption">Short name</span>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <v-icon class="ml-1" small v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            <span>A short-name identifies the object in a database or the file-system.</span>
        </v-tooltip>

        <code class="ml-2">{{ shortId }}</code>
    </div>
</template>

<script>
import { makeShortId } from '../utils'
export default {
    name: 'ShortIdInput',
    data() {
        return {
            shortId: ''
        }
    },
    props: {
        longId: String
    },
    watch: {
        longId: function (nextValue, prevValue) {
            this.shortId = makeShortId(nextValue)
        },
        shortId: function (nextValue, prevValue) {
            this.$emit('input', { nextValue })
        }
    },
    mounted() {
        this.shortId = makeShortId(this.longId)
        this.$emit('input', { nextValue: this.shortId })
    }
}
</script>
